/* eslint-disable camelcase */
// console.log('resources/assets/js/api/project.js');
/*
	Imports the Cockpit API URL from the config.
*/
// import Vue from 'vue';

import { API_CONFIG } from '../config.js';
// var moment = require('moment');

export default {
	/* GET     /api/v1/projects */
	getProjects: function (page_url) {
		// console.log(page_url);
		// Vue.InfoSwal('[API CALL] getProjects (' + page_url + ')');
		return axios.get(page_url);
	},

	/* GET /api/v1/projects/{projectID} */
	getProject: function (projectID) {
		// Vue.InfoSwal('[API CALL] getProject (' + projectID + ')');
		return axios.get(API_CONFIG.API_URL + '/projects/' + projectID);
	},

	/* POST /api/v1/projects */
	postAddNewProject: function (project) {
		// Vue.InfoSwal('[API CALL] postAddNewProject');
		console.log(project.user_uuid);
		return axios.post(API_CONFIG.API_URL + '/projects', {
			customer_id: project.customer_id,
			department_id: project.department_id,
			entity_id: project.entity_id,
			format_id: project.format_id,
			format_int_id: project.format_int_id,
			interactive_format_id: project.interactive_format_id,
			languages: project.languages,
			music_id: project.music_id,
			opportunity_number: project.opportunity_number,
			origin_id: project.origin_id,
			project_number: project.project_number,
			release_date: project.release_date,
			style_id: project.style_id,
			title: project.title,
			title_original: project.title_original,
			topics: project.topics,
			type_id: project.type_id,
			usage_rights: project.usage_rights,
			user_uuid: project.user_uuid,
			video_features: project.video_features,
			interactive_features: project.interactive_features,
			online_resource: project.online_resource
		});
	},

	/* PUT 	/api/v1/projects/{id} */
	putEditProject: function (project) {
		// console.log('putEditProject: ' + project.hash_id);
		// console.log('Project: ');
		// console.log(project);
		// Vue.InfoSwal('[API CALL] putEditProject (' + project.hash_id + ')');
		return axios.put(API_CONFIG.API_URL + '/projects/' + project.hash_id, {
			customer_id: project.customer_id,
			department_id: project.department_id,
			entity_id: project.entity_id,
			format_id: project.format_id,
			format_int_id: project.format_int_id,
			interactive_format_id: project.interactive_format_id,
			languages: project.languages,
			languages_objects: project.languages_objects,
			music_id: project.music_id,
			opportunity_number: project.opportunity_number,
			origin_id: project.origin_id,
			project_id: project.id,
			project_number: project.project_number,
			release_date: project.release_date,
			style_id: project.style_id,
			title: project.title,
			title_original: project.title_original,
			topics: project.topics,
			type_id: project.type_id,
			usage_rights: project.usage_rights,
			video_features: project.video_features,
			interactive_features: project.interactive_features,
			online_resource: project.online_resource
		});
	},

	/* DELETE	/api/v1/project/{projectID} */
	deleteProject: function (projectID) {
		// Vue.InfoSwal('[API CALL] deleteProject (' + projectID + ')');
		return axios.delete(API_CONFIG.API_URL + '/projects/' + projectID);
	},

	/* PUT 	/api/v1/projects/{id}/hide */
	putHideProject: function (projectID) {
		// Vue.InfoSwal('[API CALL] putHideProject (' + projectID + ')');
		return axios.put(API_CONFIG.API_URL + '/projects/' + projectID + '/hide');
	},

	/* PUT 	/api/v1/projects/{id}/unhide */
	putUnhideProject: function (projectID) {
		// Vue.InfoSwal('[API CALL] putUnhideProject (' + projectID + ')');
		return axios.put(API_CONFIG.API_URL + '/projects/' + projectID + '/unhide');
	}
};
